export const getNextPosition = (things: readonly { position: number }[]) =>
  things.length === 0 ? 1 : Math.max(...things.map(t => t.position)) + 1;
